// src/components/RouteLoader.jsx
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const RouteLoader = ({
  gif = '/assets/LOGO.gif',
  timeout = 3000,
  minShow = 500,
}) => {
  const location = useLocation();
  const [showLoader, setShowLoader] = useState(false);
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    let start = Date.now();
    setShowLoader(true);
    setFadeOut(false);

    const images = Array.from(document.images).filter(
      (img) => img.loading !== 'lazy' && !img.complete
    );

    const finish = () => {
      const elapsed = Date.now() - start;
      const delay = Math.max(minShow - elapsed, 0);
      setTimeout(() => {
        setFadeOut(true);
        setTimeout(() => setShowLoader(false), 400); // fade duration
      }, delay);
    };

    if (images.length === 0) {
      finish();
    } else {
      let loaded = 0;
      images.forEach((img) => {
        img.onload = img.onerror = () => {
          loaded++;
          if (loaded === images.length) finish();
        };
      });

      setTimeout(finish, timeout); // fallback timeout
    }
  }, [location]);

  if (!showLoader) return null;

  return (
    <div
      className={`fixed inset-0 z-[9999] bg-white flex items-center justify-center transition-opacity duration-500 ${
        fadeOut ? 'opacity-0 pointer-events-none' : 'opacity-100'
      }`}
    >
      <img
        src={gif}
        alt="Loading..."
        className="w-100 h-100 object-contain loader-blink"
      />
    </div>
  );
};

export default RouteLoader;
